import { fetchCurrentUserSuccess } from './fetch-current-user';
import { type CurrentUser } from './types';

type AnyAction = ReturnType<typeof fetchCurrentUserSuccess>;

export default (state: CurrentUser | null = null, action: AnyAction): CurrentUser | null => {
  switch (action.type) {
    case fetchCurrentUserSuccess.type:
      return action.payload ?? null;
    default:
      return state;
  }
};
